import {useRef, useState, useEffect} from 'react';
import { v4 as uuidv4 } from "uuid";


interface SortModel {
    onSelect: (id: string) => void;
    selectedSort: string;
}

const SortSelector: React.FC<SortModel> = (props) => {

    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
        
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    
    const handleSelect = (value: string) => {
        props.onSelect(value);
        setOpen(false);
    }

    const sort = [
        {
            id: 'alphabetic',
            title: 'Alfabetisk'
        },
        {
            id: 'published',
            title: 'Publisert'
        },
        {
            id: 'popular',
            title: 'Populær'
        },
        {
            id: 'relevance',
            title: 'Relevant'
        },        
    ]

    return (
        <div ref={ref} className='relative'>
            <div className={`${open ? 'bg-brown-25 border-brown-secondary' : 'bg-orange-primary border-orange-primary'} rounded-lg border-2 transition-all laptop:absolute laptop:top-0 laptop:right-0 laptop:z-50 max-w-32`}>
                <button type="button" onClick={() => setOpen(!open)} className='px-6 py-3 w-full text-left hover:bg-orange-25 rounded-lg flex justify-between gap-2'>
                    {sort.map((item) => {
                        if (item.id === props.selectedSort) {
                            return (
                                <span key={uuidv4()}>
                                    {item.title}
                                </span>
                            )
                        }
                    })}

                    <div
                        className={`${open ? 'icon-chevron-up' : 'icon-chevron-down'}`}
                        aria-hidden="true"
                    >
                    </div>
                </button>

                <div className={`${open ? 'h-auto' : 'h-0 hidden'} overflow-hidden flex flex-col`}>

                    {sort.map((item) => {
                        if (item.id !== props.selectedSort) {
                            return (
                                <button key={uuidv4()} onClick={() => handleSelect(item.id)} type="button" className='px-6 py-3 block w-full text-left hover:bg-orange-25 rounded-lg'>
                                    {item.title}
                                </button>
                            );
                        }
                    })}
                </div>

            </div>
        </div>
    );
};

export default SortSelector;
